const uncapitalize = str => str.charAt(0).toLowerCase() + str.slice(1);

export const titleToCamelCase = str => uncapitalize(str.replace(' ', ''));
